import React from 'react';

import './style.sass';

const Preload = () => (
  <div className="preload">
    <div className="preload__element">
      <span className="preload__elements-item icon-hexagon-shape" />
      <span className="preload__elements-item icon-hexagon-shape" />
      <span className="preload__elements-item icon-hexagon-shape" />
    </div>
  </div>
);
export default Preload;
